import React, { useEffect, useRef, useState } from "react";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";

interface CalculatorModalProps {
  isOpen: boolean;
  onClose: () => void;
}

declare global {
  interface Window {
    Desmos?: any;
  }
}

const CalculatorModal: React.FC<CalculatorModalProps> = ({
  isOpen,
  onClose,
}) => {
  const calculatorRef = useRef<HTMLDivElement | null>(null);
  const desmosInstanceRef = useRef<any>(null);
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    if (!isOpen) return;

    if (!window.Desmos) {
      const script = document.createElement("script");
      script.src =
        "https://www.desmos.com/api/v1.11/calculator.js?apiKey=dcb31709b452b1cf9dc26972add0fda6";
      script.async = true;
      script.onload = () => {
        if (window.Desmos && calculatorRef.current) {
          desmosInstanceRef.current = window.Desmos.GraphingCalculator(
            calculatorRef.current,
            {
              keypad: true,
              expressions: true,
              settingsMenu: true,
              degreeMode: false,
              showResetButtonOnGraphpaper: false,
              showMenuBar: true,
              showHamburgerMenu: true,
              showLinkToUserGuide: false,
              showLogo: true,
            }
          );
        }
      };
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    } else if (window.Desmos && calculatorRef.current) {
      desmosInstanceRef.current = window.Desmos.GraphingCalculator(
        calculatorRef.current,
        {
          keypad: true,
          expressions: true,
          settingsMenu: true,
          degreeMode: false,
          showResetButtonOnGraphpaper: false,
          showMenuBar: true,
          showHamburgerMenu: true,
          showLinkToUserGuide: false,
          showLogo: true,
        }
      );
    }

    return () => {
      if (desmosInstanceRef.current) {
        desmosInstanceRef.current.destroy();
        desmosInstanceRef.current = null;
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed top-0 left-0 h-full z-50 flex items-start pt-20"
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-lg shadow-xl p-4 ml-8 transition-all duration-300 ${
          isExpanded ? "w-[800px] h-[700px]" : "w-[450px] h-[600px]"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-2">
          <span className="font-bold text-base text-[#22336b]">Calculator</span>
          <div className="flex items-center gap-2">
            <button
              className="w-9 h-9 flex items-center justify-center border border-gray-300 rounded-lg bg-white hover:bg-gray-100 transition-colors"
              onClick={() => setIsExpanded(!isExpanded)}
              title={isExpanded ? "Collapse" : "Expand"}
            >
              {isExpanded ? (
                <FullscreenExitOutlined
                  style={{ fontSize: 20, color: "#555" }}
                />
              ) : (
                <FullscreenOutlined style={{ fontSize: 20, color: "#555" }} />
              )}
            </button>
            <button
              className="text-sm text-gray-600 hover:text-black font-bold px-2 py-1"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
        <div ref={calculatorRef} className="w-full h-[calc(100%-32px)]" />
      </div>
    </div>
  );
};

export default CalculatorModal;
